// extracted by mini-css-extract-plugin
export default {"container":"code_container__Qs6r+","paper":"code_paper__AZgpR","title":"code_title__9r2cZ","subtitle":"code_subtitle__kmn6t","resendCode":"code_resendCode__UIr28"};